import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card, Table } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Get, Post, Put, DeleteSingle as Delete } from '../../../../utils/httpProvider';
import { DANHGIA_CBHD_API, CHITIET_DANHGIA_CBHD_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { trangThaiGuiKetQuaValue, objectLoaiCanBoHuongDan, loaiCanBoHuongDanValue } from '../../../../utils/define';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import * as moment from 'moment';

const customSelectStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: state.isDisabled ? '#ffffff' : '#ffffff',
    }),
    singleValue: (base, state) => ({
        ...base,
        color: state.isDisabled ? '#495057' : base.color,
    })
};

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <span className="text-muted small">Không có file</span>
                )}
            </div>
        </Form.Group>
    );
};

const getEnumValue = (value, valueMap) => {
    if (value === null || value === undefined || value === '') return value;
    if (typeof value === 'number') return value;
    if (typeof value === 'string' && valueMap) {
        if (valueMap[value] !== undefined) return valueMap[value];
        const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
        if (valueMap[camelCase] !== undefined) return valueMap[camelCase];
        const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
        if (matchKey) return valueMap[matchKey];
        if (!isNaN(value)) return parseInt(value);
    }
    return value;
};

const customLoaiCanBoMap = { ...loaiCanBoHuongDanValue, canBoHuongDanChinh: 0, canBoHuongDanPhu: 1, dongHuongDan: 2 };

const DanhGiaCBHDForm = ({ thayDoiCBHDId, chiTietThayDoiCBHDs = [], readOnly = false, isUserView = false, refetchParent = () => {} }) => {
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        fileQuyetDinh: '',
        trangThaiGuiKetQua: trangThaiGuiKetQuaValue.chuaGui
    });
    const [chiTiets, setChiTiets] = useState([]);
    const [deletedChiTietIds, setDeletedChiTietIds] = useState([]);

    const { data: danhGiaRes, refetch: refetchDanhGia, isLoading } = useQuery(
        ['danhGiaThayDoiCBHD', thayDoiCBHDId], 
        () => Get(`${DANHGIA_CBHD_API.GET_BY_THAYDOI_ID}/${thayDoiCBHDId}`),
        { 
            enabled: !!thayDoiCBHDId,
            refetchOnWindowFocus: false 
        }
    );

    const danhGiaData = danhGiaRes?.data || danhGiaRes || null;

    useEffect(() => {
        const fetchChiTiets = async () => {
            if (danhGiaData && danhGiaData.id) {
                setFormData({
                    soQuyetDinh: danhGiaData.soQuyetDinh || '',
                    ngayQuyetDinh: danhGiaData.ngayQuyetDinh ? moment(danhGiaData.ngayQuyetDinh).format('YYYY-MM-DD') : '',
                    fileQuyetDinh: danhGiaData.fileQuyetDinh || '',
                    trangThaiGuiKetQua: danhGiaData.trangThaiGuiKetQua !== undefined ? danhGiaData.trangThaiGuiKetQua : trangThaiGuiKetQuaValue.chuaGui
                });

                try {
                    const ctRes = await Get(`${CHITIET_DANHGIA_CBHD_API.GET_BY_DANHGIA_ID}/${danhGiaData.id}`);
                    if (ctRes) {
                        const rawData = ctRes.data || ctRes;
                        let list = rawData.$values || rawData;
                        if (!Array.isArray(list)) list = [];
                        setChiTiets(list.map(ct => ({
                            ...ct,
                            loaiCanBoHuongDan: getEnumValue(ct.loaiCanBoHuongDan, customLoaiCanBoMap)
                        })));
                    }
                } catch (e) {
                    console.error('Lỗi lấy chi tiết CBHD', e);
                }
            } else {
                setFormData({
                    soQuyetDinh: '',
                    ngayQuyetDinh: '',
                    fileQuyetDinh: '',
                    trangThaiGuiKetQua: trangThaiGuiKetQuaValue.chuaGui
                });
                
                if (chiTietThayDoiCBHDs && chiTietThayDoiCBHDs.length > 0) {
                    setChiTiets(chiTietThayDoiCBHDs.map(ct => ({
                        id: null,
                        hoTen: ct.hoTen || '',
                        loaiCanBoHuongDan: getEnumValue(ct.loaiCanBoHuongDan, customLoaiCanBoMap),
                        donViCongTac: ct.donViCongTac || '',
                        fileLyLichKhoaHoc: ct.fileLyLichKhoaHoc || '',
                        fileMinhChung: ct.fileMinhChung || ''
                    })));
                } else {
                    setChiTiets([{ hoTen: '', loaiCanBoHuongDan: null, donViCongTac: '', fileLyLichKhoaHoc: '', fileMinhChung: '' }]);
                }
            }
        };

        fetchChiTiets();
    }, [danhGiaData, chiTietThayDoiCBHDs]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleChiTietChange = (index, field, value) => {
        const newChiTiets = [...chiTiets];
        newChiTiets[index][field] = value;
        setChiTiets(newChiTiets);
    };

    const addChiTiet = () => {
        setChiTiets([...chiTiets, { hoTen: '', loaiCanBoHuongDan: null, donViCongTac: '', fileLyLichKhoaHoc: '', fileMinhChung: '' }]);
    };

    const removeChiTiet = (index) => {
        const newChiTiets = [...chiTiets];
        const removed = newChiTiets.splice(index, 1)[0];
        if (removed.id) {
            setDeletedChiTietIds([...deletedChiTietIds, removed.id]);
        }
        setChiTiets(newChiTiets);
    };

    const handleSave = async (isSend = false) => {
        // Validate chi tiets
        for (let i = 0; i < chiTiets.length; i++) {
            const ct = chiTiets[i];
            if (!ct.hoTen) {
                toast.error(`Vui lòng nhập họ tên cán bộ ở dòng ${i + 1}`);
                return;
            }
        }

        setSaving(true);
        try {
            const dataToSave = {
                thayDoiCBHDId: thayDoiCBHDId,
                soQuyetDinh: formData.soQuyetDinh,
                ngayQuyetDinh: formData.ngayQuyetDinh || null,
                fileQuyetDinh: formData.fileQuyetDinh,
                trangThaiGuiKetQua: isSend ? trangThaiGuiKetQuaValue.daGui : formData.trangThaiGuiKetQua
            };
            
            let currentDanhGiaId = null;

            if (danhGiaData && danhGiaData.id) {
                currentDanhGiaId = danhGiaData.id;
                await Put(DANHGIA_CBHD_API.UPDATE_ITEM, currentDanhGiaId, dataToSave);
            } else {
                const res = await Post(DANHGIA_CBHD_API.CREATE, null, dataToSave);
                let savedData = res;
                if (res && res.ok) {
                    try { savedData = await res.json(); } catch(e){}
                }
                currentDanhGiaId = savedData?.id || savedData?.data?.id || savedData?.Id || savedData?.data?.Id;
            }

            if (currentDanhGiaId) {
                // Delete removed items
                for (const delId of deletedChiTietIds) {
                    await Delete(CHITIET_DANHGIA_CBHD_API.DELETE_ITEM, delId);
                }
                setDeletedChiTietIds([]);

                // Save items
                for (const ct of chiTiets) {
                    const ctData = {
                        danhGiaCBHDId: currentDanhGiaId,
                        hoTen: ct.hoTen,
                        loaiCanBoHuongDan: ct.loaiCanBoHuongDan,
                        donViCongTac: ct.donViCongTac,
                        fileLyLichKhoaHoc: ct.fileLyLichKhoaHoc,
                        fileMinhChung: ct.fileMinhChung
                    };

                    if (ct.id) {
                        await Put(CHITIET_DANHGIA_CBHD_API.UPDATE_ITEM, ct.id, { ...ctData, id: ct.id });
                    } else {
                        await Post(CHITIET_DANHGIA_CBHD_API.CREATE, null, ctData);
                    }
                }
            }

            toast.success(isSend ? 'Gửi kết quả thành công!' : 'Lưu thông tin thành công!');
            await refetchDanhGia();
            refetchParent();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded border">
            <h5 className="font-weight-bold text-primary mb-4 border-bottom pb-2">
                <i className="fas fa-clipboard-check mr-2"></i>Đánh giá thay đổi cán bộ hướng dẫn
            </h5>
            
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Quyết định thay đổi</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="font-weight-bold">Số quyết định</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name="soQuyetDinh" 
                                    value={formData.soQuyetDinh} 
                                    onChange={handleChange} 
                                    disabled={readOnly}
                                    className={readOnly ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="font-weight-bold">Ngày quyết định</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="ngayQuyetDinh" 
                                    value={formData.ngayQuyetDinh} 
                                    onChange={handleChange} 
                                    disabled={readOnly}
                                    className={readOnly ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            {readOnly ? (
                                <FieldDisplayFile label="File quyết định" value={formData.fileQuyetDinh} />
                            ) : (
                                <Form.Group>
                                    <DocumentInput
                                        labelTitle="File quyết định"
                                        value={formData.fileQuyetDinh}
                                        onChangeProp={(url) => setFormData({ ...formData, fileQuyetDinh: url })}
                                        readOnly={readOnly}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Danh sách cán bộ hướng dẫn</Card.Header>
                <Card.Body>
                    <div>
                        {chiTiets.length > 0 ? (
                            chiTiets.map((cb, idx) => (
                                <div key={idx} className="border p-3 mb-3 bg-white rounded position-relative">
                                    <h6 className="font-weight-bold mb-3 text-danger">Cán bộ hướng dẫn {idx + 1}</h6>
                                    {!readOnly && (
                                        <div className="position-absolute" style={{ top: '10px', right: '10px', zIndex: 10 }}>
                                            <Button type="button" variant="outline-danger" size="sm" onClick={() => removeChiTiet(idx)} title="Xóa cán bộ hướng dẫn">
                                                <i className="fas fa-trash"></i>
                                            </Button>
                                        </div>
                                    )}
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Họ và tên <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    value={cb.hoTen} 
                                                    onChange={(e) => handleChiTietChange(idx, 'hoTen', e.target.value)}
                                                    disabled={readOnly}
                                                    placeholder="Nhập họ tên"
                                                    className={readOnly ? "bg-white" : ""}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>Vai trò cán bộ <span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={objectLoaiCanBoHuongDan}
                                                    value={objectLoaiCanBoHuongDan.find(opt => opt.value === cb.loaiCanBoHuongDan) || null}
                                                    onChange={(opt) => handleChiTietChange(idx, 'loaiCanBoHuongDan', opt ? opt.value : null)}
                                                    isDisabled={readOnly}
                                                    placeholder="Chọn vai trò"
                                                    styles={customSelectStyles}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Đơn vị công tác</Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    value={cb.donViCongTac} 
                                                    onChange={(e) => handleChiTietChange(idx, 'donViCongTac', e.target.value)}
                                                    disabled={readOnly}
                                                    placeholder="Nhập đơn vị công tác"
                                                    className={readOnly ? "bg-white" : ""}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6} className="mb-3">
                                            {readOnly ? (
                                                <FieldDisplayFile label="File lý lịch" value={cb.fileLyLichKhoaHoc} />
                                            ) : (
                                                <DocumentInput
                                                    labelTitle="File lý lịch"
                                                    value={cb.fileLyLichKhoaHoc}
                                                    onChangeProp={(url) => handleChiTietChange(idx, 'fileLyLichKhoaHoc', url)}
                                                    readOnly={readOnly}
                                                />
                                            )}
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            {readOnly ? (
                                                <FieldDisplayFile label="File minh chứng" value={cb.fileMinhChung} />
                                            ) : (
                                                <DocumentInput
                                                    labelTitle="File minh chứng"
                                                    value={cb.fileMinhChung}
                                                    onChangeProp={(url) => handleChiTietChange(idx, 'fileMinhChung', url)}
                                                    readOnly={readOnly}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            ))
                        ) : (
                            <div className="text-center p-3 border rounded text-muted">Không có cán bộ nào.</div>
                        )}
                        
                        {!readOnly && (
                            <Button variant="outline-primary" size="sm" onClick={addChiTiet} className="mt-2">
                                <i className="fas fa-plus mr-1"></i> Thêm cán bộ
                            </Button>
                        )}
                    </div>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave(false)} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                    <Button variant="primary" className="ml-2" onClick={() => handleSave(true)} disabled={saving || formData.trangThaiGuiKetQua === trangThaiGuiKetQuaValue.daGui}>
                        {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Đang gửi...</> : <><i className="fas fa-paper-plane mr-2"></i> {formData.trangThaiGuiKetQua === trangThaiGuiKetQuaValue.daGui ? 'Đã gửi kết quả' : 'Gửi kết quả'}</>}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default DanhGiaCBHDForm;
